/**
 * Created by shubham on 8/5/18.
 */

import { Component } from '@angular/core';
import { APPCONFIG } from '../../../config';
import { MdDialog } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpService } from '../../../shared/services/http.service';
import { SessionHandler } from '../../../shared/services/session-handler.service';
import { DialogComponent } from '../../../dialog/dialog.component';
import {TranslateService} from 'ng2-translate';


@Component({
    selector: 'add-admin',
    template: require('./addAdmin.component.html')
})
export class AddAdminComponent {

    dialogRef;
    userDetails: any;
    isSystemAdmin:boolean = false;
    isBUManager:boolean = false;
    isRegionalAdmin:boolean = false;
    isServiceOwner:boolean = false;
    isTradePartner:boolean = false;
    isSubUser:boolean = false;
    adminRoles = [];
    settings = {};
    languages = [];
    defaultLanguageId: any;
    AdminForm: FormGroup;
    AdminFormDetails: any;
    emailPattern = APPCONFIG.emailPattern;
    isDisabled = true;
    wpassId:any;
    selectedAdminItems:any;

    constructor(private sessionHandler:SessionHandler, public httpService : HttpService, public dialog: MdDialog, private formBuilder: FormBuilder,
        private translate: TranslateService) {

        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));

        if(this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0){
            if(this.userDetails.roleCode.includes(APPCONFIG.systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.BUManager)) {
                this.isBUManager = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.serviceOwner)) {
                this.isServiceOwner = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.tradePartner)) {
                this.isTradePartner = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.subuser)) {
                this.isSubUser = true;
            }
        } else {
            this.httpService.noUserError();
        }

        if(this.isSystemAdmin){
            this.getAdminRoles();
            this.getLanguages();
        }
    }

    validateName(event: any) {
        return APPCONFIG.validNameRegex.test(event.key);
    }
    public getAdminRoles(){
        this.httpService.getRequest('superUserOperationsApi/v1/adminRoles').subscribe(
            res => { this.saveAdminRoles(res); },
            err => { this.httpService.onEnd(); }
        );
    }

    public saveAdminRoles(res){
        if(res && res.items){
            this.adminRoles = res.items;
        }
        this.httpService.onEnd();
    }

    public getLanguages(){
        this.httpService.getRequest('lookupDataOperationsApi/v1/language').subscribe(
            res => { this.saveLanguage(res); },
            err => { this.httpService.onEnd(); }
        );
    }

    public saveLanguage(res){
        if(res && res.items){
            this.languages = res.items;

            for(let l in this.languages){
                if(this.languages[l]['id'] == 'EN'){
                    this.defaultLanguageId = this.languages[l]['id'];
                }
            }
        }
        this.httpService.onEnd();
    }

    buildForm() {
        this.AdminForm = this.formBuilder.group({
            firstName: this.formBuilder.control(null, [Validators.required]),
            lastName: this.formBuilder.control(null, [Validators.required]),
            email: this.formBuilder.control(null, [Validators.required, Validators.pattern(this.emailPattern)]),
            languageId: this.formBuilder.control(null, [Validators.required]),
            roleData: this.formBuilder.control(null, [Validators.required]),
            userId_WPASS: this.formBuilder.control(null, [Validators.required]),
        });
        this.AdminForm.valueChanges.subscribe(data => {
            this.AdminFormDetails = this.AdminForm.getRawValue();

            this.AdminFormDetails['roleId'] = [];
            for (let d in this.AdminFormDetails.roleData){
                this.AdminFormDetails['roleId'].push(this.AdminFormDetails.roleData[d]['id']);
            }

            this.AdminFormDetails.validate = this.AdminForm.valid;
        });
    }
    api1:boolean = true;
    buroleSelect(item: any){
        
        if(this.selectedAdminItems.find(x=> x.id == "5639445604728832")){
        if(this.wpassId){
            if(this.api1){
                /* this.dialogRef = this.dialog.open(DialogComponent);
                this.dialogRef.componentInstance.msg = "This user id is not able to assign manager"; */
            }  
        }
        else{
            if(this.selectedAdminItems.find(x=> x.id == "5639445604728832")){
               var sliceFor =  this.selectedAdminItems.findIndex(x=> x.id == "5639445604728832");
                this.selectedAdminItems.splice(sliceFor);
                if(this.selectedAdminItems.length == 0){this.selectedAdminItems = []}
                console.log(this.selectedAdminItems);
                
            }}}
            else{
                if(this.wpassId){ }
            }
}

    onBlurWpass(){
        if(this.selectedAdminItems){
        console.log(this.selectedAdminItems);
        if(this.selectedAdminItems.find(x=> x.id == "5639445604728832")){
            if(this.wpassId){
                if(this.api1){
                    /* this.dialogRef = this.dialog.open(DialogComponent);
                    this.dialogRef.componentInstance.msg = "This user id is not able to assign manager"; */
                    if(this.selectedAdminItems.find(x=> x.id == "5639445604728832")){
                        var sliceFor =  this.selectedAdminItems.findIndex(x=> x.id == "5639445604728832");
                         this.selectedAdminItems.splice(sliceFor);
                         if(this.selectedAdminItems.length == 0){this.selectedAdminItems = []}
                        console.log(this.selectedAdminItems);
                     }
                }
            }
        }
        else if(this.wpassId){ }
        
    }
    }


    noWpassId(item:any){
        console.log(item);
    }
    public saveAdminData(){
        this.httpService.postRequest(this.AdminFormDetails,'superUserOperationsApi/v1/admin').subscribe(
            res => { this.saveAdminResponse(res); },
            err => { this.httpService.onEnd(); }
        );
    }

    public saveAdminResponse(res){
        if(res){
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = "Admin added successfully";
            this.dialogRef.afterClosed().subscribe(result => {
                window.location.href = '#/app/manage-admin/list';
            });
        } else if(res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'save_failed';
            this.httpService.onEnd();
        }
    }

    ngOnInit() {
        this.buildForm();

        var temp_settings = {singleSelection: false,text:"",labelKey: "name",selectAllText:"",unSelectAllText:"",classes:"myclass custom-class"};
        this.translate.get('Select Role').subscribe((res: string) => {temp_settings.text = res;
            if(temp_settings.text&&temp_settings.selectAllText&&temp_settings.unSelectAllText) {this.settings=temp_settings;}
        });
        this.translate.get('select_all').subscribe((res: string) => {temp_settings.selectAllText=res;
            if(temp_settings.text&&temp_settings.selectAllText&&temp_settings.unSelectAllText) {this.settings=temp_settings;}
        });
        this.translate.get('unselect_all').subscribe((res: string) => {temp_settings.unSelectAllText=res;
            if(temp_settings.text&&temp_settings.selectAllText&&temp_settings.unSelectAllText) {this.settings=temp_settings;}
        });
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/system-level-setting/adminManagement/addAdmin/addAdmin.component.ts